// import Swiper JS
import Swiper, { Autoplay, EffectFade} from 'swiper';

Swiper.use([EffectFade, Autoplay]);

document.addEventListener("DOMContentLoaded", function() {
    var swiperBanner = new Swiper(".banner-home", {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        autoplay: true,
        speed: 1000,
    });
});